/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoGoogleStorePurchaseLogListRequest model module.
 * @module model/LogControllerDtoGoogleStorePurchaseLogListRequest
 * @version 1.0
 */
class LogControllerDtoGoogleStorePurchaseLogListRequest {
    /**
     * Constructs a new <code>LogControllerDtoGoogleStorePurchaseLogListRequest</code>.
     * @alias module:model/LogControllerDtoGoogleStorePurchaseLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        LogControllerDtoGoogleStorePurchaseLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>LogControllerDtoGoogleStorePurchaseLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoGoogleStorePurchaseLogListRequest} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoGoogleStorePurchaseLogListRequest} The populated <code>LogControllerDtoGoogleStorePurchaseLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoGoogleStorePurchaseLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('productNo')) {
                obj['productNo'] = ApiClient.convertToType(data['productNo'], 'Number');
            }
            if (data.hasOwnProperty('productId')) {
                obj['productId'] = ApiClient.convertToType(data['productId'], 'String');
            }
            if (data.hasOwnProperty('orderId')) {
                obj['orderId'] = ApiClient.convertToType(data['orderId'], 'String');
            }
            if (data.hasOwnProperty('purchaseToken')) {
                obj['purchaseToken'] = ApiClient.convertToType(data['purchaseToken'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoGoogleStorePurchaseLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoGoogleStorePurchaseLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of LogControllerDtoGoogleStorePurchaseLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['productId'] && !(typeof data['productId'] === 'string' || data['productId'] instanceof String)) {
            throw new Error("Expected the field `productId` to be a primitive type in the JSON string but got " + data['productId']);
        }
        // ensure the json data is a string
        if (data['orderId'] && !(typeof data['orderId'] === 'string' || data['orderId'] instanceof String)) {
            throw new Error("Expected the field `orderId` to be a primitive type in the JSON string but got " + data['orderId']);
        }
        // ensure the json data is a string
        if (data['purchaseToken'] && !(typeof data['purchaseToken'] === 'string' || data['purchaseToken'] instanceof String)) {
            throw new Error("Expected the field `purchaseToken` to be a primitive type in the JSON string but got " + data['purchaseToken']);
        }

        return true;
    }


}

LogControllerDtoGoogleStorePurchaseLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['accountNo'] = undefined;

/**
 * @member {Number} productNo
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['productNo'] = undefined;

/**
 * @member {String} productId
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['productId'] = undefined;

/**
 * @member {String} orderId
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['orderId'] = undefined;

/**
 * @member {String} purchaseToken
 */
LogControllerDtoGoogleStorePurchaseLogListRequest.prototype['purchaseToken'] = undefined;






export default LogControllerDtoGoogleStorePurchaseLogListRequest;

